<template>
  <b-container class="my-2">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h4 class="text-center mb-2">Editar Item Farmaco</h4>

          <b-form @submit.prevent="submitForm">
            <div class="row">
              <hr class="col-12">

              <div class="col-6 mb-1">
                <label>Código: <span class="text-danger">*</span></label>
                <b-form-input v-model="medicamento.codigo" type="text" required />
              </div>

              <div class="col-6 mb-1">
                <label>Presentación:</label>
                <b-form-input v-model="medicamento.presentacion" type="text" />
              </div>

              <div class="col-12 mb-1">
                <label>Nombre: <span class="text-danger">*</span></label>
                <b-form-input v-model="medicamento.nombre" type="text" required />
              </div>

              <div class="col-6 mb-1">
                <label>Cantidad Máxima: <span class="text-danger">*</span></label>
                <b-form-input v-model="medicamento.numMax" type="number" required />
              </div>

              <hr class="col-12">

              <b-row class="col-12">
                <h6 class="col-12">Precio:</h6>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 100px;">ISSFA N1</label>
                  <InputNumber v-model="medicamento.precios.issfa_n1" decimal />
                </div>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 100px;">ISSFA N2</label>
                  <InputNumber v-model="medicamento.precios.issfa_n2" decimal />
                </div>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 100px;">IESS N1</label>
                  <InputNumber v-model="medicamento.precios.iess_n1" decimal />
                </div>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 100px;">PARTICULAR</label>
                  <InputNumber v-model="medicamento.precios.particular" decimal />
                </div>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 100px;">ISSPOL N1</label>
                  <InputNumber v-model="medicamento.precios.isspol_n1" decimal />
                </div>

              </b-row>

              <hr class="col-12">

              <b-row class="col-12">
                <h6 class="col-12">Estados:</h6>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 80px;">IESS</label>
                  <b-form-checkbox v-model="medicamento.estados.iess" switch />
                </div>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 80px;">ISSFA</label>
                  <b-form-checkbox v-model="medicamento.estados.issfa" switch />
                </div>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 80px;">ISSPOL</label>
                  <b-form-checkbox v-model="medicamento.estados.isspol" switch />
                </div>

                <div class="col-6 d-flex align-items-center mb-1">
                  <label class="mb-0 mr-2" style="width: 80px;">PARTICULAR</label>
                  <b-form-checkbox v-model="medicamento.estados.particular" switch />
                </div>
              </b-row>

              <hr class="col-12">

              <b-row class="col-12">
                <h6 class="col-12">Establecimientos:</h6>
                <div class="row estab-grid col-12">
                  <div
                    v-for="est in medicamento.establecimientosEstado"
                    :key="est.value"
                    class="col-6 mb-2"
                  >
                    <div class="estab-item">
                      <span class="estab-label">{{ est.text }}</span>
                      <b-form-checkbox v-model="est.activo" switch class="mb-0" />
                    </div>
                  </div>
                </div>
              </b-row>

              <div class="col-12 d-flex justify-content-end mt-3">
                <b-button type="submit" variant="primary" class="mx-2">
                  Actualizar Medicamento
                </b-button>
                <b-button @click="salir()" variant="danger">
                  Salir
                </b-button>
              </div>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import rutas from "@/assets/utils/rutas.json";
import { establecimientosService } from '@/views/administracion/services';
import { InputNumber } from '@/shared/components';
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormCheckbox,
    InputNumber,
  },
  props: {
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      medicamento: {
        id: "",
        token: "",
        nombre: "",
        numMax: "",
        codigo: "",
        precioNeto: 0,
        precioTecho: 0,
        presentacion: "",
        estado: 0,
        establecimiento: "",
        establecimientosEstado: [],
        precios: {
          issfa_n1: "0",
          issfa_n2: "0",
          iess_n1: "0",
          particular: "0",
          isspol_n1: "0",
        },
        estados: {
          iess: false,
          issfa: false,
          isspol: false,
          particular: false,
        },
        estadoJson: {},
        precioJson: {},
      },
      establecimientosList: [],
    };
  },
  async created() {
    this.establecimientosList = await establecimientosService.getForSelect();
    this.fetchMedicamento(this.token);
  },

  methods: {
    salir() {
      this.$router.push({ name: "consultar_cartera_farmaco" });
    },

    async submitForm() {
      const precioNetoFormateado = parseFloat(this.medicamento.precioNeto || 0).toFixed(4);
      const precioTechoFormateado = parseFloat(this.medicamento.precioTecho || 0).toFixed(4);

      const query = `
        mutation ActualizarMedicamento(
          $idMedicamento: Int!, 
          $datos: MedicamentoInput!
        ) {
          actualizarMedicamento(medicamentoDatos: {
            id: $idMedicamento,
            datos: $datos
          }) {
            medicamentoActualizado {
              nombre
              codigo
              estado
              numMax
              precioNeto
              precioTecho
              presentacion
              establecimiento
            }
            message
            status
          }
        }
      `;

      const variables = {
        idMedicamento: parseInt(this.medicamento.id),
        datos: {
          nombre        : this.medicamento.nombre,
          numMax        : parseInt(this.medicamento.numMax),
          codigo        : this.medicamento.codigo,
          precioNeto    : precioNetoFormateado,
          precioTecho   : precioTechoFormateado,
          presentacion  : this.medicamento.presentacion,
          estado        : this.medicamento.estado,
          establecimiento : this.medicamento.establecimientosEstado
            .filter(e => e.activo)
            .map(e => e.value)
            .join(",") || this.medicamento.establecimiento,
          estadoJson    : this.medicamento.estados ? JSON.stringify(this.medicamento.estados) : null,
          precioJson    : this.medicamento.precios ? JSON.stringify(this.medicamento.precios) : null,
        },
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
      
        if (response.data.data.actualizarMedicamento.status === "success") {
          // Mostrar alerta de éxito
          await this.$swal({
            icon: "success",
            title: "Éxito",
            text: "El medicamento se actualizó correctamente.",
          });

          this.$router.go(0); 
        } else {
          throw new Error(response.data.data.actualizarMedicamento.message);
        }
      } catch (error) {
        // Mostrar alerta de error
        await this.$swal({
          icon: "error",
          title: "Error",
          text:
            error.message || "Hubo un problema al actualizar el medicamento.",
        });
      }
    },


    async fetchMedicamento() {
      const query = `
        query ObtenerMedicamento($tokenMedicamento: String!) {
          medicamento(tokenmedicamento: $tokenMedicamento) {
            medicamento {
              id
              token
              nombre
              codigo
              estado
              numMax
              precioNeto
              precioTecho
              presentacion
              establecimiento
              estadoJson
              precioJson
            }
            message
            status
          }
        }
      `;

      const variables = {
        tokenMedicamento: this.token,
      };

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
        
        if (response.data.data.medicamento.status === "Success") {
          if (response.data.data.medicamento.medicamento) {
            const medicamentoData = response.data.data.medicamento.medicamento;
            const estados = this.parseFlexibleJson(medicamentoData.estadoJson);
            const precios = this.parseFlexibleJson(medicamentoData.precioJson);

            this.medicamento = {
              ...this.medicamento,
              ...medicamentoData,
              estados: {
                iess: !!estados.iess,
                issfa: !!estados.issfa,
                isspol: !!estados.isspol,
                particular: !!estados.particular,
              },
              precios: {
                issfa_n1: precios.issfa_n1 ?? "0.00",
                issfa_n2: precios.issfa_n2 ?? "0.00",
                iess_n1: precios.iess_n1 ?? "0.00",
                particular: precios.particular ?? (medicamentoData.precioNeto ? String(medicamentoData.precioNeto) : "0.00"),
                isspol_n1: precios.isspol_n1 ?? "0.00",
              },
              establecimientosEstado: this.mapEstablecimientosEstado(medicamentoData.establecimiento),
            };
          }
        } else {
          console.error("Error al obtener la receta:", response.data.message);
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },
    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value
            .replace(/'/g, '"')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (error) {
          console.warn('No se pudo parsear JSON flexible', value);
          return {};
        }
      }
    },
    mapEstablecimientosEstado(establecimientosStr = '') {
      const safeVal = establecimientosStr || '';
      const ids = Array.isArray(safeVal)
        ? safeVal.map(e => (e.id ? e.id : e)).map(i => String(i).trim())
        : safeVal
            .toString()
            .split(',')
            .map(i => i.trim())
            .filter(Boolean);

      const baseList =
        (this.establecimientosList && this.establecimientosList.length
          ? this.establecimientosList
          : []) || [];

      const listToUse =
        baseList.length > 0
          ? baseList
          : ids.map(id => ({ value: id, text: id })) || [];

      return listToUse.map(est => ({
        ...est,
        activo: ids.includes(String(est.value)),
      }));
    },
  },
};
</script>

<style scoped>
.estab-grid .col-6 {
  padding-left: 8px;
  padding-right: 8px;
}

.estab-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  background: #f9fbff;
  min-height: 38px;
}

.estab-label {
  font-weight: 600;
  font-size: 0.9rem;
  color: #344050;
}
</style>
